import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'

const babylonCanadaB2g: PartnerConfig = {
  branding: {
    logo: [
      {
        src: '/images/babylon.png',
        alt: 'Babylon logo config',
      },
    ],
  },
  config: {
    id: 'telus-b-2-g',
    name: 'Babylon Canada B2G',
    appName: DEFAULT.APPNAMES.BABYLON_CANADA_B2G,
    acceptLanguage: 'en-CA',
    codes: {
      membership: 'CANB2G',
    },
    partnerUrlSlug: 'babylon-canada-b2g',
    steps: [
      {
        slug: 'welcome',
        component: 'welcome',
      },
      {
        slug: 'registration',
        component: 'registration',
      },
      {
        slug: 'thank-you',
        component: 'summary',
      },
    ],
    fields: [
      [DEFAULT.FIELDS.EMAIL],
      [
        DEFAULT.FIELDS.FIRST_NAME,
        DEFAULT.FIELDS.LAST_NAME,
        DEFAULT.FIELDS.PASSWORD,
        DEFAULT.FIELDS.DATE_OF_BIRTH,
        {
          ...DEFAULT.FIELDS.ADDRESS_STATE_CODE,
          props: {
            options: [
              {
                label: 'Ontario',
                value: 'ON',
              },
            ],
          },
        },
      ],
    ],
  },
  content: {
    'en-CA': {
      steps: [
        {
          title: 'Enter your email address',
          stepperLabel: 'Welcome',
          copy: [],
          productFeatures: [
            {
              icon: 'ChatFilled',
              title: 'Check your symptoms quickly and easily',
            },
          ],
        },
        {
          title: 'Register',
          stepperLabel: 'Registration',
          copy: ['Add a few details to access 24/7 health support'],
        },
        {
          title: 'Thank you',
          stepperLabel: 'Thank You',
          copy: [
            'Sign into the Webapp to book complete a Triage flow, available at no cost through Ontario Health.',
          ],
          imgUrl: '/images/babylon-ios-app.png',
          cta: {
            label: 'Proceed with question or triage',
            webAppPartialLink: '/',
            showDownloadButtons: false,
          },
          showPromotionBox: false,
        },
      ],
      footerLinks: DEFAULT.FOOTERLINKS.CAN,
    },
  },
}

export default babylonCanadaB2g
